import React, { useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import './ToastNotification.css';

// Toast Component (original name, isolated styles)
export const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const icons = {
    success: <CheckCircle size={20} />,
    error: <XCircle size={20} />,
    info: <AlertCircle size={20} />
  };

  return (
    <div className={`isolated-toast-notification isolated-toast-${type}`}>
      <div className="isolated-toast-icon-wrapper">{icons[type]}</div>
      <div className="isolated-toast-content">{message}</div>
      <button onClick={onClose} className="isolated-toast-close-btn">✕</button>
    </div>
  );
};

// Confirm Dialog Component (original name, isolated styles)
export const ConfirmDialog = ({ message, onConfirm, onCancel }) => {
  return (
    <div className="isolated-modal-overlay" onClick={onCancel}>
      <div className="isolated-confirm-container" onClick={(e) => e.stopPropagation()}>
        <div className="isolated-confirm-header">
          <h2 className="isolated-confirm-title">
            <span className="isolated-confirm-title-icon">
              <AlertCircle size={24} />
            </span>
            Confirm Action
          </h2>
        </div>
        <div className="isolated-confirm-body">
          <p className="isolated-confirm-message">{message}</p>
        </div>
        <div className="isolated-confirm-footer">
          <button 
            type="button" 
            onClick={onCancel} 
            className="isolated-btn isolated-btn-cancel"
          >
            No
          </button>
          <button 
            type="button" 
            onClick={onConfirm} 
            className="isolated-btn isolated-btn-confirm"
          >
            Yes
          </button>          
        </div>
      </div>
    </div>
  );
};

// Custom Hook for Toast (original name)
export const useToast = () => {
  const [toast, setToast] = React.useState(null);

  const showToast = React.useCallback((message, type = 'info') => {
    setToast({ message, type });
  }, []);

  const hideToast = React.useCallback(() => {
    setToast(null);
  }, []);

  return { toast, showToast, hideToast };
};

// Custom Hook for Confirm Dialog (original name)
export const useConfirm = () => {
  const [confirmDialog, setConfirmDialog] = React.useState(null);

  const showConfirm = React.useCallback((message) => {
    return new Promise((resolve) => {
      setConfirmDialog({
        message,
        onConfirm: () => {
          setConfirmDialog(null);
          resolve(true);
        },
        onCancel: () => {
          setConfirmDialog(null);
          resolve(false);
        }
      });
    });
  }, []);

  return { confirmDialog, showConfirm };
};